import { BaseResponseHttp } from './commons.model';
import { IProducts, CallPlace } from './myActivity.model';
import { TaxData, DeliveredDirections, HoursRange } from '../../model/http/profile.model';
import { TotalDescriptionShopping } from '../../model/local/general.model';
import { BooleanCons, NumberCons, StringConst } from '../../constants/const';
import { PaymentCard } from '../../model/http/profile.model';
import { PatientsConfigByReRecipe, PrescriptionNameInfo } from './prescriptionName';
import { PaymentInformation } from '../local/payment.model';
import { CreditNotes } from './favorBalance.model';
import { DirectionsType } from '../../model/local/directions.type';
export class IOrdersRes extends BaseResponseHttp {
  response?: IOrders[];
}
export class IOrders {
  transactionId: string | undefined;
  createName: string | undefined;
  startDate: string | undefined;
  totalProducts: number;
  totalPieces: number;
  amountTotal: number | undefined;
  prescriptionUrl: string[];
  constructor() {
    this.totalProducts = 0;
    this.totalPieces = 0;
    this.prescriptionUrl = [];
  }
}

export class IProductDetailResponse extends BaseResponseHttp {
  response = new DetailResponse();
}

export class OrderDetailResponse extends BaseResponseHttp {
  response = new OrderDetail();
}

export class OrderDetail {
  orderHeader: OrderHeader;
  detailsProducts: IProducts[] = [];
  paymentMethod: PaymentInformation;
  constructor() {
    this.orderHeader = new OrderHeader();
    this.detailsProducts = [];
    this.paymentMethod = new PaymentInformation();
  }
}
export class DetailResponse {
  orderHeader: OrderHeader;
  details: DetailUser[];
  paymentMethod: PaymentInformation;
  constructor() {
    this.orderHeader = new OrderHeader();
    this.details = [];
    this.paymentMethod = new PaymentInformation();
  }
}

export class DetailUser {
  clientName: string = StringConst.empty;
  detailsProducts: IProducts[] = [];
}

export class DetailDeliveryAddress {
  betweenStreets?: string;
  references?: string;
  etablishmentName?: string;
}
export class OrderHeader {
  pedidoId: number;
  transactionID?: string;
  transactionId?: string;
  transactionIdAuthorized?: string;
  cardCode: string;
  address?: string[];
  invoiceAddressList?: string[];
  deliveryAddress?: string;
  invoiceAddress?: string;
  iva?: number;
  rfc?: string;
  razonSocial?: string;
  adresType?: string;
  totalProducts: number;
  totalPieces: number;
  addressDeliveryId: string;
  addressInvoiceId: string;
  zipCode: string;
  zipCodeInvoice?: string;
  emailInvoice: string;
  subTotal: number;
  shippingCost: number;
  discount: number;
  needTaxData: boolean;
  totalUtilities: number;
  totalOfUtilities?: number;
  storePickup: number;
  createName?: string;
  isPaymentAuthorized?: number;
  needsRecipe: number;
  isRecipeAuthorized: number;
  amountTotal: number;
  addressId: string;
  phoneDelivery: string;
  shipToCode: string;
  payToCode: string;
  hasDiscountSpecial: boolean;
  percentDiscountSpecial: number;
  creditNoteAmount: number;
  promotionalCodeAmount: number;
  shippingCostDiscount: number;
  promotionalCode: string;
  invoiceType: string;
  constructor() {
    this.cardCode = StringConst.empty;
    this.pedidoId = NumberCons.zero;
    this.needsRecipe = NumberCons.zero;
    this.isRecipeAuthorized = NumberCons.zero;
    this.storePickup = NumberCons.one;
    this.totalOfUtilities = 0;
    this.subTotal = NumberCons.zero;
    this.addressDeliveryId = StringConst.empty;
    this.addressInvoiceId = StringConst.empty;
    this.zipCode = StringConst.empty;
    this.emailInvoice = StringConst.empty;
    this.discount = NumberCons.zero;
    this.totalUtilities = NumberCons.zero;
    this.totalProducts = NumberCons.zero;
    this.totalPieces = NumberCons.zero;
    this.shippingCost = NumberCons.zero;
    this.amountTotal = NumberCons.zero;
    this.addressId = StringConst.empty;
    this.phoneDelivery = StringConst.empty;
    this.shipToCode = StringConst.empty;
    this.payToCode = StringConst.empty;
    this.needTaxData = BooleanCons.false;
    this.hasDiscountSpecial = BooleanCons.false;
    this.percentDiscountSpecial = NumberCons.zero;
    this.creditNoteAmount = NumberCons.zero;
    this.promotionalCodeAmount = NumberCons.zero;
    this.shippingCostDiscount = NumberCons.zero;
    this.promotionalCode = StringConst.empty;
    this.invoiceType = StringConst.empty;
  }
}
export class BackIProductDetailResponse {
  detailsProducts?: IProducts[];
  totalDescription: TotalDescriptionShopping;
  taxDataStorage: TaxData;
  directionData: DeliveredDirections;
  payment: PaymentCard;
  place?: CallPlace;
  docNum?: string;
  startingPlace: CallPlace;
  needRecipe: boolean;
  numRecipe?: number;
  keyStorage?: string;
  numProduct?: number;
  taxDataBack: TaxData;
  directionDataBack: DeliveredDirections;
  paymentBack: PaymentCard;
  rol?: string;
  requirePatientName: boolean;
  prescriptionNameInfo: PrescriptionNameInfo[];
  recipesConfig: PatientsConfigByReRecipe[];
  recipesCorrect: boolean;
  wasChanged: boolean;
  typeDirectionSelection: number;
  creditNotes: CreditNotes[];
  carUpdatedTicks: number;
  promotionalCode: string;
  promotionalCodeAmount: number;
  deliveryComments: string;
  hoursRange: HoursRange;
  typeDirectionSelected: DirectionsType;
  typeAddressShippingCode: string[];
  isFirsTimePrescriptionData?: boolean;
  constructor() {
    this.prescriptionNameInfo = [];
    this.requirePatientName = false;
    this.detailsProducts = [];
    this.totalDescription = new TotalDescriptionShopping();
    this.place = CallPlace.default;
    this.startingPlace = CallPlace.default;
    this.needRecipe = BooleanCons.false;
    this.rol = StringConst.empty;
    this.numRecipe = NumberCons.zero;
    this.keyStorage = StringConst.empty;
    this.payment = new PaymentCard();
    this.paymentBack = new PaymentCard();
    this.taxDataStorage = new TaxData();
    this.directionData = new DeliveredDirections();
    this.taxDataBack = new TaxData();
    this.directionDataBack = new DeliveredDirections();
    this.recipesConfig = [];
    this.recipesCorrect = BooleanCons.false;
    this.wasChanged = BooleanCons.false;
    this.typeDirectionSelection = NumberCons.zero;
    this.creditNotes = [];
    this.carUpdatedTicks = NumberCons.zero;
    this.promotionalCode = StringConst.empty;
    this.promotionalCodeAmount = NumberCons.zero;
    this.deliveryComments = StringConst.empty;
    this.hoursRange = new HoursRange();
    this.typeDirectionSelected = DirectionsType.default;
    this.typeAddressShippingCode = [];
  }
}

export class BackIProductDetailStorage {
  object: BackIProductDetailResponse;
  init: number;
  initDirection: number;
  initTaxData: number;
  initPaymentData: number;
  cardCode: string;
  transactionId: string;
  constructor() {
    this.object = new BackIProductDetailResponse();
    this.init = NumberCons.zero;
    this.initTaxData = NumberCons.zero;
    this.initPaymentData = NumberCons.zero;
    this.initDirection = NumberCons.zero;
    this.cardCode = StringConst.empty;
    this.transactionId = StringConst.empty;
  }
}
export class InfoDialogChangeTaxAndDirrection {
  place: CallPlace;
  taxData: TaxData[];
  deliveredDirections: DeliveredDirections[];
  startingPlace: CallPlace;
  constructor() {
    this.place = CallPlace.default;
    this.taxData = [];
    this.deliveredDirections = [];
    this.startingPlace = CallPlace.default;
  }
}
